import Header from './components/Header';
import Hero from './components/Hero';
import Menu from './components/Menu';
import Facilities from './components/Facilities';
import Access from './components/Access';
import Booking from './components/Booking';
import Footer from './components/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-offwhite">
      <Header />
      <main>
        <section id="hero">
          <Hero />
        </section>
        <section id="menu">
          <Menu />
        </section>
        <section id="facilities">
          <Facilities />
        </section>
        <section id="access">
          <Access />
        </section>
        <section id="booking">
          <Booking />
        </section>
      </main>
      <Footer />
    </div>
  );
}
